import React from 'react';
import BasicSlideToggle from '../BasicSlideToggle';

const FormCheckbox = ({ name, value, label, checked, onChange, helpText, mark, error }) => {
  return (
    <div className={'form-checkbox'}>
      <div className="form__row">
          <BasicSlideToggle
            name={name}
            labelPosition="right"
            label={label || value}
            mark={mark}
            error={error}
            checked={checked}
            onChange={onChange}
            help={helpText}
            trackStyle={{
              marginLeft: '0'
            }}
          />
      </div>
    </div>
  );
};

export default FormCheckbox;
